import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=2ae0592d&"
import script from "./ImageOverlay.vue?vue&type=script&lang=ts&"
export * from "./ImageOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ImageOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VIcon,VOverlay})
